<section class="reports-container">
  @if (!drawer.opened) {
    <button aria-label="open side panel" class="sidebar-button" (click)="toggleSidePanel()">
      <mds-icon
        [key]="icons.RIGHT_PANEL_OPEN"
        [width]="24"
        [height]="24"
        class="button-icon icon-margin-right"
      ></mds-icon>
    </button>
  }

  <mat-drawer-container class="reports-content">
    <mat-drawer #drawer mode="side" position="end" class="reports-drawer">
      <app-report-sidepanel
        [drawerRef]="drawer"
        [loading]="loadingReportData"
        [data]="sidePanelData"
        [rid]="rid"
        (valueChanged)="sidepanelEvent($event)"
      ></app-report-sidepanel>
    </mat-drawer>
    <mat-drawer-content #drawerContent class="drawer-content">
      <app-report-content
        [reportGridData]="reportGridData"
        [selectedRow]="selectedRow"
        [gridOptions]="gridOptions"
        [templateBody]="templateBody"
        (onReloadReport)="reloadReport()"
        [loading]="loadingReportData"
        [loadingMessage]="loadingMessage"
        (onGridKeyPressed)="gridKeyPressed($event)"
      ></app-report-content>
    </mat-drawer-content>
  </mat-drawer-container>
</section>
